import { envVariables } from '@fabric-ui/utils';

/**
 * Centralized constants for the SOAR frontend application.
 */

const API_BASE = envVariables.VITE_API_URL || '';

export const APP_CONFIG = {
  API_PORT: 8026,
  BASE_URL: `${API_BASE}/socautomation/`,
};

export const API_ROUTES = {
  PLAYBOOKS: 'playbooks',
  AUTOMATION_RULE: 'automation/rule',
  CATALOG: 'catalog/trigger-objects',
  EXECUTION_HISTORY: 'history/executions',
  PLAYBOOK_LOOKUP: 'playbook-lookup',
};

/**
 * Canonical entity-category slugs used across SOAR (playbook picker target lists, entity detail
 * cards, recommendation affected-entities, etc.). Use these instead of the bare string literals.
 */
export const TARGET_ENTITY_TYPE = {
  USER: 'user',
  ASSET: 'asset',
  ARTIFACT: 'artifact',
} as const;

export type TargetEntityType = (typeof TARGET_ENTITY_TYPE)[keyof typeof TARGET_ENTITY_TYPE];

export const entityToProjMapping: Record<string, string> = {
  INCIDENT: 'incidents',
  ALERT: 'uber_alerts',
  VULNERABILITY: 'vulnerabilities',
  FINDING: 'findings',
  ASSET: 'assets',
  USER: 'uber_users',
  IDENTITY_FINDING: 'uber_identity_findings',
};

/**
 * Converts the PascalCase entity type carried on ticket info (`EntityTypeConfigKeys`, e.g.
 * `IdentityFinding`) to the snake_case catalog convention that playbooks and automation rules
 * are stored with (e.g. `identity_finding`). Single-word types (Alert, Incident, User) are
 * unaffected.
 *
 * Deliberately mirrors the server-side conversion — keep the two in step:
 * `AutomationActivityImpl.toCatalogEntityType`, itself mirroring
 * `CatalogConfigurationService.camelToSnake`.
 */
export const toPlaybookEntityType = (entityType?: string): string | undefined =>
  entityType?.replace(/([a-z])([A-Z]+)/g, '$1_$2').toLowerCase();
